import { Component } from "@angular/core";
import { ApePagePlaceholderComponent } from "../ape-page-placeholder/ape-page-placeholder.component";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";

@Component({
  selector: "ape-admin-impersonate-placeholder",
  templateUrl: "./ape-admin-impersonate-placeholder.component.html",
  standalone: true,
  host: { class: "w-full h-full" },
  imports: [
    ApePagePlaceholderComponent,
    TranslatePipe
  ]
})
export class ApeAdminImpersonatePlaceholderComponent {
  /**
   * Chiavi di traduzione per type safety
   */
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;
}